var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"height":_vm.height,"width":_vm.width,"src":_vm.source},on:{"error":function($event){_vm.error = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }